import { Injectable } from '@angular/core'
import { WindowRef } from '@spartacus/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class EbCarouselService {
  MAX_HEIGHT = 3

  constructor(private winRef: WindowRef) {}
  getItemsPerSlideByHeight(nativeElement: HTMLElement, itemHeight: string): Observable<number> {
    return this.winRef.resize$.pipe(
      map(() => nativeElement.clientHeight),
      map(totalHeight => this.calculateItems(totalHeight, itemHeight))
    )
  }
  private calculateItems(availableHeight: number, itemHeight: string) {
    let calculatedItems = 0
    if (itemHeight.endsWith('px')) {
      const num = itemHeight.substring(0, itemHeight.length - 2)
      calculatedItems = availableHeight / (num as any as number)
    }
    if (itemHeight.endsWith('%')) {
      const perc = itemHeight.substring(0, itemHeight.length - 1)
      calculatedItems = availableHeight / (availableHeight * ((perc as any) / 100))
    }

    const items = Math.floor(calculatedItems) || 1
    return items > this.MAX_HEIGHT ? items : this.MAX_HEIGHT
  }
}
